import { LogicalOperators } from "@validereinc/utilities";
import classNames from "classnames/bind";
import { unset } from "es-toolkit/compat";
import { produce } from "immer";
import React from "react";
import { Button } from "../../Button";
import {
  getDeepReference,
  getStringKeyFromArrayKey,
} from "../FilterBuilder.helpers";
import styles from "../FilterBuilder.module.scss";
import { FilterBuilderFilterType, FilterBuilderProps } from "../types";

const cx = classNames.bind(styles);

export const FilterBuilderDeleteFieldButton = ({
  setFilter,
  onFilterChange,
  myKey,
  onDelete,
}: {
  myKey: Array<string | number>;
  setFilter: React.Dispatch<React.SetStateAction<FilterBuilderFilterType>>;
  onFilterChange?: FilterBuilderProps["onFilterChange"];
  onDelete?: () => void;
}) => (
  <Button
    className={cx("action-button")}
    icon="minus-circle"
    onClick={() => {
      setFilter((oldFilter: FilterBuilderFilterType) => {
        const producedFilter = produce(
          oldFilter,
          (draft: FilterBuilderFilterType) => {
            // Splice directly from $and or $or arrays, instead of just "delete"ing the path:
            if (
              myKey.length > 2 &&
              (myKey[myKey.length - 3] === LogicalOperators.and ||
                myKey[myKey.length - 3] === LogicalOperators.or)
            ) {
              const indexToDelete = myKey[myKey.length - 2] as number;
              if (typeof indexToDelete !== "number") return;
              const referenceToArray = getDeepReference(
                draft,
                myKey.slice(0, -2)
              );
              referenceToArray.splice(indexToDelete, 1);
            } else {
              unset(draft, getStringKeyFromArrayKey(myKey));
            }
          }
        );

        onFilterChange?.(producedFilter);

        return producedFilter;
      });
      onDelete?.();
    }}
  />
);
